import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Row, Col, Form, Button, Spinner, Alert } from 'react-bootstrap';
import { BASE_URL } from '../../Config';
import 'bootstrap/dist/css/bootstrap.min.css';

const Register_Supervisor = ({
  companyUserId: companyUserIdProp,
  companyName: companyNameProp,
  embedded = false,
  onSuccess,
}) => {
  const [userId, setUserId] = useState(companyUserIdProp || '');
  const [companyName, setCompanyName] = useState(companyNameProp || '');
  const [supervisorName, setSupervisorName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [address, setAddress] = useState('');
  const [contactNumber, setContactNumber] = useState('');
  const [cnic, setCnic] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (companyUserIdProp) {
      setUserId(companyUserIdProp);
    }
    if (companyNameProp) {
      setCompanyName(companyNameProp);
    }

    if (companyUserIdProp && companyNameProp) return;

    const storedUserData = sessionStorage.getItem('user');
    if (storedUserData) {
      const userData = JSON.parse(storedUserData);
      if (!companyUserIdProp) {
        if (userData.userRole === 'Company') {
          setUserId(userData.userId || userData.companyId || '');
        } else {
          setUserId(
            userData.selectedCompanyId ||
              userData.companyId ||
              userData.companyProfileId ||
              ''
          );
        }
      }
      if (!companyNameProp) {
        setCompanyName(
          userData.selectedCompanyName ||
            userData.companyName ||
            (userData.userRole === 'Company' ? userData.name : '') ||
            ''
        );
      }
    }
  }, [companyUserIdProp, companyNameProp]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!userId) {
      Swal.fire('Error', 'Company not selected. Please select a company first.', 'error');
      return;
    }
    if (!supervisorName || !email || !password) {
      Swal.fire('Error', 'Please complete all required fields.', 'error');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        `${BASE_URL}Register_Supervisor`,
        {
          userId,
          supervisorName,
          email,
          password,
          address,
          contactNumber,
          cnic,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            accept: '*/*',
          },
        }
      );

      Swal.fire({
        title: response.data.responseCode === '0000' ? 'Success' : 'Error',
        text: response.data.message,
        icon: response.data.responseCode === '0000' ? 'success' : 'error',
      });

      if (response.data.responseCode === '0000') {
        setSupervisorName('');
        setEmail('');
        setPassword('');
        setAddress('');
        setContactNumber('');
        setCnic('');
        if (typeof onSuccess === 'function') onSuccess();
      }
    } catch (error) {
      console.error('Register Supervisor Error:', error);
      Swal.fire('Error', error.response?.data?.message || 'An unexpected error occurred. Please try again.', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={embedded ? '' : 'co-page'}>
      <div className={embedded ? '' : 'container-xl mt-3'}>
        <div className={embedded ? '' : 'card co-card p-3 p-md-4'}>
        {!embedded && <h2 className="text-center mb-4 h4">Register Supervisor</h2>}
        {embedded && <h5 className="mb-3">Supervisor Details</h5>}

        {companyName && (
          <Alert variant="light" className="border small py-2">
            Company: <strong>{companyName}</strong>
          </Alert>
        )}

        <Form onSubmit={handleSubmit}>
          <Row className="g-3">
            <Col xs={12} md={6}>
              <Form.Floating>
                <Form.Control
                  id="supervisorName"
                  placeholder="Supervisor Name"
                  value={supervisorName}
                  onChange={(e) => setSupervisorName(e.target.value)}
                  required
                />
                <label htmlFor="supervisorName">Supervisor Name *</label>
              </Form.Floating>
            </Col>
            <Col xs={12} md={6}>
              <Form.Floating>
                <Form.Control
                  id="supervisorEmail"
                  type="email"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <label htmlFor="supervisorEmail">Email *</label>
              </Form.Floating>
            </Col>
            <Col xs={12} md={6}>
              <div className="input-group">
                <div className="form-floating flex-grow-1">
                  <input
                    id="supervisorPassword"
                    type={showPassword ? 'text' : 'password'}
                    className="form-control"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <label htmlFor="supervisorPassword">Password *</label>
                </div>
                <button
                  className="btn btn-outline-secondary"
                  type="button"
                  onClick={() => setShowPassword((v) => !v)}
                >
                  <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`} />
                </button>
              </div>
            </Col>
            <Col xs={12} md={6}>
              <Form.Floating>
                <Form.Control
                  id="supervisorContact"
                  placeholder="Contact Number"
                  value={contactNumber}
                  onChange={(e) => setContactNumber(e.target.value)}
                />
                <label htmlFor="supervisorContact">Contact Number</label>
              </Form.Floating>
            </Col>
            <Col xs={12} md={6}>
              <Form.Floating>
                <Form.Control
                  id="supervisorCnic"
                  placeholder="CNIC"
                  value={cnic}
                  onChange={(e) => setCnic(e.target.value)}
                />
                <label htmlFor="supervisorCnic">CNIC</label>
              </Form.Floating>
            </Col>
            <Col xs={12} md={6}>
              <Form.Floating>
                <Form.Control
                  id="supervisorAddress"
                  placeholder="Address"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
                <label htmlFor="supervisorAddress">Address</label>
              </Form.Floating>
            </Col>
          </Row>

          <div className="d-grid d-md-flex justify-content-md-end mt-4">
            <Button type="submit" className="px-4" disabled={loading}>
              {loading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Registering...
                </>
              ) : (
                'Register Supervisor'
              )}
            </Button>
          </div>
        </Form>
        </div>
      </div>
    </div>
  );
};

export default Register_Supervisor;
